<script>

import { mapActions } from 'vuex'
import Manifest from './contents/_RecycleManifest.vue'
import Basic from './contents/_RecycleFinalDisposalBasic.vue'
import RecycleFinalDisposalFlow from "@/driver/pages/dialogs/contents/_RecycleFinalDisposalFlow.vue";
import DataTableModal from "@/driver/pages/dialogs/_DataTableModal.vue";

export default {
  name: 'RecycleFinalDisposalReportDialog',
  components: {
    DataTableModal,
    RecycleFinalDisposalFlow,
    Manifest,
    Basic,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    sortType: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    /**
     * マニフェスト(1次, 2次)
     */
    manifestLevel: {
      type: String,
      default: "first_manifest"
    },
  },
  data() {
    return {
      manifests: null,
      key: 0,
      copyTargetPattern: null,
      enablePrimaryManifestModal: false,
      primaryManifestHeaders: [
        { value: 'second_manifest_no', text: '2次マニフェスト番号' },
        { value: 'second_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_no', text: '1次マニフェスト番号' },
        { value: 'primary_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_type_name', text: 'マニフェスト区分' },
        { value: 'primary_manifest_collected_date', text: '引渡日' },
      ],
      primaryManifestResult: [],
    }
  },
  computed: {},
  watch: {
    /**
     * ダイアログ表示制御フラグの監視
     * @param newValue
     */
    enableDialog (newValue) {
      this.manifests = null
      this.scrollToTop()
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {

    /**
     * マニフェスト
     * 最終処分終了報告
     */
    ...mapActions('DriverManifestRecycleFinalDisposalReport', {
      fetchReportForManifest: 'show',
      updateReportsForManifest: 'update',
    }),

    /**
     * 処分場受入
     * 最終処分終了報告
     */
    ...mapActions('DriverOrderRecycleFinalDisposalReport', {
      fetchReportForOrder: 'show',
      updateReportsForOrder: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
      this.key += 1;
    },
    /**
     * 紐付く1次マニの自動連携チェック処理
     */
    ...mapActions("DriverManifestPrimaryManifestSyncCheck", {
      cheCheck: "create"
    }),
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {

      this.$refs.finalDisposalReportValidator.validate().then((result) => {
        if (result) {
          let params = this.buildParams();
          if (params.manifests.length === 0) {
            return
          }
          if (this.type === "Managements") {
            if (this.manifestLevel === 'first_manifest') {
              this.updateReportsForManifest({ params: params }).then(() => {
                this.$emit('registerEvent')
              })
            } else if (this.manifestLevel === 'second_manifest') {
              this.checkAndRegisterSecondManifest();
            }
          } else {
            params['order_ids'] = this.orderIds
            this.updateReportsForOrder({ params: params }).then(() => {
              this.$emit('registerEvent')
            })
          }
        }
      })
    },
    /**
     * 2次マニ
     * 登録前の1次マニへの自動連携チェック処理
     */
    checkAndRegisterSecondManifest () {
      const $self = this;
      this.cheCheck({ params: { manifest_ids: this.manifestIds }}).then((response) => {
        const result = response.result;
        const content = response.content;
        if (result.code === 'ok') {
          let params = this.buildParams();
          this.updateReportsForManifest({ params: params }).then(() => {
            this.$emit('registerEvent')
          })
        } else {
          this.primaryManifestResult = content.unsync_primary_manifests
          this.enablePrimaryManifestModal = true;
        }
      })
    },
    /**
     * 連携対象外マニフェストのダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enablePrimaryManifestModal = false;
    },
    /**
     * 連携対象外マニフェストのダイアログ 実行ボタンコールバック
     */
    dialogRegisterCallback() {
      this.dialogCloseCallback();
      let params = this.buildParams();
      this.updateReportsForManifest({ params: params }).then(() => {
        this.$emit('registerEvent')
      })
    },

    /**
     * 送信パラメータの生成
     * @return {{manifests: *[], manifest_ids: *[], type: string}}
     */
    buildParams () {
      const params = []
      this.manifests.forEach((manifest, _) => {
        if (manifest.target_for_registration) {
          const parameters = {
            id: manifest.id,
            final_disposal_standard_quantity_type: manifest.final_disposal_standard_quantity_type,
            final_disposal_quantity: manifest.final_disposal_quantity,
            manifest_recycle_disposal_reports_attributes:[]
          }
          /**
           * @property manifest_final_disposal.origin_after_disposal_ratio
           */
          for (let manifest_final_disposal of manifest.manifest_recycle_disposal_reports) {
            if (!manifest_final_disposal._destroy) {
              parameters.manifest_recycle_disposal_reports_attributes.push({
                level: manifest_final_disposal.level,
                recycle_disposer_disposal_method_id: manifest_final_disposal.recycle_disposer_disposal_method_id,
                recycle_disposer_disposal_method_detail_id: manifest_final_disposal.recycle_disposer_disposal_method_detail_id,
                before_disposal_weight: manifest_final_disposal.before_disposal_weight,
                after_disposal_weight: manifest_final_disposal.after_disposal_weight,
                before_disposal_ratio: manifest_final_disposal.before_disposal_ratio,
                after_disposal_ratio: manifest_final_disposal.after_disposal_ratio,
                sort_priority: manifest_final_disposal.sort_priority,
                final_disposal_date: manifest_final_disposal.final_disposal_date,
                final_disposal: manifest_final_disposal.final_disposal,
                comment: manifest_final_disposal.comment,
              })
            }
          }
          params.push(parameters)
        }
      })
      return {
        manifests: params,
        manifest_ids: this.manifestIds,
        type: this.type,
      }
    },

    /**
     * 初期データのロード
     */
    setVariable () {
      let params = { manifest_ids: this.manifestIds, sort_type: this.sortType }
      if (this.type === "Managements") {
        this.fetchReportForManifest({ params: params }).then((content) => {
          this.manifests = content.manifests
        }).catch((error) => {
          this.closeButtonClickEvent();
        })
      } else {
        /** 受注発注の場合はorder単位でのマニフェスト絞込が必要 */
        params["order_ids"] = this.orderIds
        this.fetchReportForOrder({ params: params }).then((content) => {
          this.manifests = content.manifests
        }).catch((error) => {
          this.closeButtonClickEvent();
        })
      }
    },

    /**
     * 基本情報
     * 登録対象チェックボックス変更 コールバック
     *
     * 同一オーダーIDを持つオブジェクトを検索し存在する場合は更新する.
     * @param order_id
     * @param checkable
     */
    targetOfRegistrationChangeCallback(order_id, checkable) {
      for (const manifest of this.manifests) {
        if (manifest.order_id === order_id) {
          manifest.target_for_registration = checkable;
        }
      }
    },

    scrollToTop () {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },

    /**
     * 複写処理
     * @param column { String } 対象プロパティ
     * @param value { String, Number } 値
     * @param object { Object, null } 再資源化等パターンオブジェクト
     */
    copyField (column, value, object) {
      if (this.isBlank(value)) {
        return;
      }

      for (let i = 0; i < this.manifests.length; i++) {
        const manifest = this.manifests[i];
        if (column === 'final_disposal_standard_quantity_type') {
          /* 基準重量 */
          manifest.final_disposal_standard_quantity_type = value
          const ref = this.$refs[`final-basic-${i}`][0];
          ref.onStandardQuantityChange();
        } else if (column === 'final_disposal_quantity') {
          /* 重量 */
          manifest.final_disposal_quantity = value
        } else if (column === 'pattern_id') {
          /* 再資源化等パターン */
          manifest.pattern_id = value
          this.copyTargetPattern = object;
        }
      }
    },

    /**
     * パターン一覧の初期化を行う.
     * @param index
     */
    clearRecyclePatterns (index) {
      this.manifests[index].manifest_recycle_disposal_reports = [];
      this.manifests[index].first_level_method_detail_ids = [];
      const ref = this.$refs[`final-basic-${index}`][0];
      this.manifests[index].pattern_id = null;
      this.manifests[index].pattern = null;
      ref.reloadPatterns();
    },

    /**
     * 最終処分終了日のコピーを行う.
     * 同一処分場処理方法詳細IDを持つレコードに対し日付のコピーを行う
     */
    copyFinalDisposalDate () {

      /*
       * 先頭のリストから処分場処理方法詳細IDでキー情報を作成する。
       */
      const baseManifest = this.manifests[0];

      const finalDisposalDays = [];
      baseManifest.manifest_recycle_disposal_reports.forEach(report => {
        if (report.level > 1 && report.final_disposal_date && report.final_disposal_date) {
          finalDisposalDays.push({
            key: `${report.recycle_disposer_disposal_method_detail_id}`,
            date: report.final_disposal_date
          });
        }
      })

      /* 先頭より後のリストを走査し、連結したキー情報を持つ行が存在する場合は最終処分終了日を複写 */
      this.manifests.forEach((manifest, index) => {
        if (index > 0) {
          manifest.manifest_recycle_disposal_reports.forEach(report => {
            const obj = finalDisposalDays.find(v => v.key === `${report.recycle_disposer_disposal_method_detail_id}`);
            if (obj) {
              report.final_disposal_date = obj.date;
            }
          });
        }
      })
    },
  }
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    scrollable
    persistent
    width="2000"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="finalDisposalReportValidator"
    >
      <v-card flat>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            最終処分終了報告（個別登録）再資源化
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifests"
          style="max-height: 70vh;overflow-y: scroll"
          class="card-layer"
        >
          <v-card
            v-for="(manifest, index) in manifests"
            :key="manifest.id"
            flat
          >
            <v-card-text
              class="px-2 "
              :class="{ 'bg-disabled': !manifest.target_for_registration, 'pt-2': index === 0 }"
            >
              <v-row dense>

                <!-- マニフェスト情報 -->
                <v-col
                  cols="12"
                  md="3"
                >
                  <manifest
                    caller-type="final_disposal_report"
                    :manifest.sync="manifests[index]"
                    @targetOfRegistrationChange="targetOfRegistrationChangeCallback"
                  />
                </v-col>
                <!-- /マニフェスト情報 -->

                <!-- 再資源化等情報 -->
                <v-col
                  cols="12"
                  md="5"
                >
                  <basic
                    :ref="`final-basic-${index}`"
                    :manifest.sync="manifests[index]"
                    :is-first-field="index === 0 && manifests.length > 1"
                    :copy-target-pattern="copyTargetPattern"
                    @copy:field="copyField"
                  />
                </v-col>
                <!-- /再資源化等情報 -->

                <!-- 最終処分終了日を複写 -->
                <v-col cols="12" md="4">
                  <div style="position: relative;height: 100%">
                    <div style="position: absolute;right: 0;bottom: 0;">
                      <v-btn
                        v-if="index === 0 && manifests.length > 1"
                        :disabled="!manifest.target_for_registration"
                        color="primary"
                        small
                        @click="copyFinalDisposalDate"
                      >
                        最終処分終了日を複写
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <!-- /最終処分終了日を複写 -->
              </v-row>

              <v-divider />

              <!-- 処理フロー -->
              <v-row>
                <v-col>
                  <recycle-final-disposal-flow
                    :manifest.sync="manifests[index]"
                    :is-first-field="index === 0 && manifests.length > 1"
                  />
                </v-col>
              </v-row>
              <!-- /処理フロー -->

              <!-- 処分場処理方法のクリア -->
              <div class="text-right">
                <v-btn
                  :disabled="!manifest.target_for_registration"
                  color="primary"
                  small
                  @click="clearRecyclePatterns(index)"
                >
                  処分場処理方法のクリア
                </v-btn>
              </div>
              <!-- /処分場処理方法のクリア -->

            </v-card-text>
            <v-divider v-if="index < manifests.length - 1" />
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="manifests===null"
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>

      </v-card>
    </validation-observer>

    <data-table-modal
      :descriptions="['自動連携されないマニフェストがあります。', '対象の１次マニフェストは手動で最終処分終了報告を登録してください。']"
      :enable="enablePrimaryManifestModal"
      :headers="primaryManifestHeaders"
      :items="primaryManifestResult"
      positive
      positive-caption="継続して登録"
      @close="dialogCloseCallback"
      @positiveCallback="dialogRegisterCallback"
    />
  </v-dialog>
</template>

